import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';

/**
 * Servicio en el cual se apoya el modulo de observatory.module para invocar las funciones
 * Si queremos llamar a las funciones de observatory debemos instanciar el modulo, no el servicio
 */
@Injectable()
export class ObservatoryService {
  private global = [];
  private fetching: boolean;
  private subscriptions: Array<Subscription> = [];

  constructor(
  ) {
  }
  /**
   * Instancia un dato como observable global de la página
   * @param data id del elemento a instanciar
   * @param value valor del elemento a instanciar
   */
  public setData(data, value) {
    if (!this.global[data]) {
        this.global[data] = new BehaviorSubject(value);
    }
    this.global[data].next(value);
  }

  /**
   * Recupera un dato como observable no suscrito
   * @param data id del elemento que recuperar
   */
  public getData(data) {
    if (!this.global[data]) {
      this.setData(data, '');
    }
    return this.global[data].asObservable();
  }

  public getValue(data) {
    if (!this.global[data]) {
      this.setData(data, '');
    }
    return this.global[data].getValue();
  }
}
